import React from 'react';

import { Link } from 'react-router-dom';

const renderLinksList = ({ data, createLink, createLabel }) => {
  if (!data) {
    return '';
  }

  const links = data
    .map((item) => (
      <Link
        key={item.id}
        className="text-blue-600 underline"
        to={createLink(item)}
      >
        {createLabel(item)}
      </Link>
    ))
    .reduce((prev, curr) => (prev ? [prev, ', ', curr] : [curr]), '');

  return links;
};

export default renderLinksList;
